module.exports = __webpack_public_path__ + "qr_code_ios_faco.3719905.png";